(function(){var MAX=window.__zdMax||{},TIER=window.__zdTier||{};
  var busy=false;
  function getMax(it){
    var k=String(it.product_id);
    if(MAX[k]!==undefined) return Promise.resolve(MAX[k]);
    return fetch('/products/'+it.handle).then(function(r){return r.text()}).then(function(h){
      var m=h.match(/data-max="(\d+)"/);MAX[k]=m?parseInt(m[1],10):0;return MAX[k];
    }).catch(function(){MAX[k]=0;return 0});
  }
  function note(msg){
    var d=document.getElementById('zd-max-note');
    if(!d){d=document.createElement('div');d.id='zd-max-note';
      d.style.cssText='position:fixed;left:50%;transform:translateX(-50%);bottom:20px;z-index:99999;background:#222;color:#fff;padding:12px 18px;border-radius:6px;font-size:14px;max-width:90vw;text-align:center';
      document.body.appendChild(d);}
    d.textContent=msg;d.style.display='block';setTimeout(function(){d.style.display='none'},6000);
  }
  function warn(cart){
    var sums={};
    cart.items.forEach(function(it){var t=TIER[String(it.product_id)];if(t){t.split(',').forEach(function(x){if(!x)return;sums[x]=(sums[x]||0)+it.quantity})}});
    var over=Object.keys(sums).some(function(k){return sums[k]>4});
    var b=document.getElementById('zd-ship-warn');
    if(over){
      if(!b){b=document.createElement('div');b.id='zd-ship-warn';
        b.style.cssText='position:fixed;left:50%;transform:translateX(-50%);top:70px;z-index:99998;background:#b45309;color:#fff;padding:12px 18px;border-radius:6px;font-size:14px;max-width:90vw;text-align:center';
        document.body.appendChild(b);}
      b.textContent='Shipping cannot be calculated automatically for this many pieces. Please contact us on WhatsApp or email and we will arrange it for you.';b.style.display='block';
    } else if(b){b.style.display='none';}
  }
  function guard(){
    if(busy) return;busy=true;
    fetch('/cart.js',{credentials:'same-origin'}).then(function(r){return r.json()}).then(function(cart){
      var byP={};cart.items.forEach(function(it){(byP[it.product_id]=byP[it.product_id]||[]).push(it)});
      var pids=Object.keys(byP);
      return Promise.all(pids.map(function(p){return getMax(byP[p][0])})).then(function(maxes){
        var updates={},changed=false;
        pids.forEach(function(p,i){
          var mx=maxes[i];if(!mx) return;
          var left=mx;
          byP[p].forEach(function(it){
            var q=Math.min(it.quantity,Math.max(left,0));left-=q;
            if(q!==it.quantity){updates[it.key]=q;changed=true;}
          });
        });
        if(!changed){warn(cart);return;}
        return fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({updates:updates})}).then(function(){
          note('Maximum quantity reached for this product. If you want more please contact us.');
          if(/\/cart/.test(location.pathname)) setTimeout(function(){location.reload()},1200);
          document.dispatchEvent(new CustomEvent('cart:refresh'));
        });
      });
    }).catch(function(){}).then(function(){busy=false});
  }
  var _f=window.fetch;
  window.fetch=function(){
    var u=arguments[0],url=(typeof u==='string')?u:(u&&u.url)||'';
    var p=_f.apply(this,arguments);
    if(/\/cart\/(add|change|update)/.test(url)&&!/zdskip/.test(url)){p.then(function(){setTimeout(guard,300)}).catch(function(){});}
    return p;
  };
  if(window.jQuery){jQuery(document).ajaxComplete(function(e,x,s){if(s&&/\/cart\/(add|change|update)/.test(s.url||'')) setTimeout(guard,300)});}
  document.addEventListener('DOMContentLoaded',guard);
})();
